module.exports = __webpack_public_path__ + "static/img/searchUBO.88570387.png";